import { RecordValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredEmptyAllowedString, requiredNonEmptyString, validatePayload, } from '../../utils/validate-payload.js';
export const registerTab = createAction('tab/register', (payload) => {
    const schema = new RecordValue({
        values: {
            id: requiredNonEmptyString,
            expression: requiredEmptyAllowedString,
        },
    });
    return validatePayload(payload, schema);
});
export const updateActiveTab = createAction('tab/updateActiveTab', (id) => {
    return validatePayload(id, requiredNonEmptyString);
});
